module.exports = __webpack_public_path__ + "img/15.08f0afec.png";